<nav class="navbar navbar-expand-lg">
  <div class="container-fluid">
    <button
      class="sidebar-toggle"
      type="button"
      (click)="toggleSidebar()"
      [attr.aria-label]="'nav.openNavigation' | translate"
    >
      <i class="material-icons">menu</i>
    </button>
    <div class="navbar-wrapper">
      <app-page-header></app-page-header>
    </div>
    <div class="navbar-actions">
      @if (currentUser) {
        <button
          class="user-profile-chip"
          type="button"
          [matMenuTriggerFor]="userMenu"
          [attr.aria-label]="'nav.openUserMenu' | translate"
        >
          <div class="user-avatar" [class.has-photo]="!!currentUser.photo">
            @if (currentUser.photo) {
              <img
                [src]="currentUser.photo"
                [alt]="currentUser.name + ' ' + currentUser.surname"
              />
            } @else {
              <span>{{ userInitials }}</span>
            }
          </div>
          <div class="user-info">
            <strong>{{ currentUser.name }} {{ currentUser.surname }}</strong>
          </div>
          <span class="user-menu-caret">
            <i class="material-icons user-menu-icon">expand_more</i>
          </span>
        </button>
      }
    </div>
  </div>
</nav>

<mat-menu #userMenu="matMenu" xPosition="before" class="user-dropdown-menu">
  <button mat-menu-item type="button" (click)="navigateToProfile()">
    <span class="menu-item-icon"
      ><i class="material-icons">manage_accounts</i></span
    >
    <span class="menu-item-label">{{ 'nav.profile' | translate }}</span>
  </button>
  <button mat-menu-item type="button" [matMenuTriggerFor]="languageMenu">
    <span class="menu-item-icon"><i class="material-icons">language</i></span>
    <span class="menu-item-label">{{ 'common.language' | translate }}</span>
    <span class="menu-item-value">
      {{ ('common.languages.' + currentLanguage) | translate }}
    </span>
  </button>
  <button
    mat-menu-item
    type="button"
    (click)="logout()"
    class="menu-item-danger"
  >
    <span class="menu-item-icon"><i class="material-icons">logout</i></span>
    <span class="menu-item-label">{{ 'nav.logout' | translate }}</span>
  </button>
</mat-menu>

<mat-menu
  #languageMenu="matMenu"
  xPosition="before"
  class="user-dropdown-menu language-dropdown-menu"
>
  @for (language of languages; track language) {
    <button
      mat-menu-item
      type="button"
      [class.language-option--active]="currentLanguage === language"
      (click)="changeLanguage(language)"
    >
      <span class="menu-item-icon">
        <i class="material-icons">
          {{ currentLanguage === language ? 'check' : 'language' }}
        </i>
      </span>
      <span class="menu-item-label">
        {{ ('common.languages.' + language) | translate }}
      </span>
    </button>
  }
</mat-menu>
